module.exports = __webpack_public_path__ + "img/footer-mail.d902c1d9.svg";